// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu__submenu--3QFEn","list":"Submenu__list--3MiRl","featured":"Submenu__featured--2FnUp"};
    if(module.hot) {
      // 1571674793406
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  